import { Form } from '@/components';
import { useTranslation } from 'react-i18next';
import { useReportingProjectsLookupSource } from '@/views';

interface Props {
  name: string;
  communityId?: string | string[];
  label?: React.ReactNode;
  placeholder?: string;
  showCommunityName?: boolean;
}

export function ReportingProjectSelect(props: Props) {
  const { communityId, name, label, placeholder, showCommunityName } = props;
  const projectsDataSource = useReportingProjectsLookupSource(
    showCommunityName ?? true,
    communityId,
  );
  const { t } = useTranslation();

  return (
    <Form.AsyncSelect
      key={`${communityId}`}
      name={name}
      dataSource={projectsDataSource}
      required
      mode="multiple"
      maxTagCount={2}
      maxTagTextLength={10}
      label={label}
      placeholder={placeholder}
      selectAll={{
        selectAllLabel: t('reports.homeStatus.selectAll'),
        unselectAllLabel: t('reports.homeStatus.unselectAll'),
      }}
    />
  );
}
